import { KeyboardEvent, useRef, useEffect } from "react";
import { titleMRClass } from "src/components/common/common";
import { handleKeyDown } from "src/utils/commonForm/commonFormUtils";

interface Props {
	title?: string;
	value: string;
	editable: boolean;
	titleless?: boolean;
	name?: string;
	onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		inputStyle: string;
	};
	maxLength?: number;
	onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
	onLoadFocus?: boolean;
	placeholder?: string;
	rows?: number;
}

export const TextareaForm = (props: Props) => {
	const {
		title,
		value,
		editable,
		titleless = false,
		name,
		onChange,
		onBlur,
		wrapperOption = {
			wrapperStyle: "w-[500px] min-w-[500px] mr-[10px] mb-[5px] h-full",
			titleStyle: "w-[150px] min-w-[150px] text-left",
			inputStyle: "w-[400px] min-w-[400px]",
		},
		maxLength = 1000,
		onLoadFocus = false,
		placeholder = '',
		rows = 3,
	} = props;

	const inputRef = useRef<HTMLTextAreaElement>(null);

	useEffect(() => {
		if (onLoadFocus) {
			inputRef.current?.focus();
		}
	}, [onLoadFocus]);

	//onKeyDown에 문제생길시 상황을 고려해서 수정해야함
	//수정하는거 자체는 1순위로 둬야하는데, 다른 컴포넌트와의 호환성 고려
	const onKeyDown = props.onKeyDown != null ?
		props.onKeyDown :
		(e: KeyboardEvent<HTMLTextAreaElement>) => {
			if (!onChange) return;
			onChange(e as unknown as React.ChangeEvent<HTMLTextAreaElement>);
		}

	return (
		<div className={`flex ${wrapperOption.wrapperStyle}`}>
			{title &&
				<>
					<p className={`${wrapperOption.titleStyle} form-title ${titleMRClass} cursor-pointer ${titleless ? 'hidden' : ''}`}
						style={{ height: 'fit-content' }}
						onClick={() => inputRef.current?.focus()} 
						tabIndex={ editable ? 0 : -1}
						>
						{title}
					</p>
					<div className={`relative ${wrapperOption.inputStyle}`}>
						<textarea
							className={`border-[1px] rounded-[4px] px-[2px] w-full resize-none
								${editable ? "bg-white" : "bg-gray-disable"} h-full`
							}
							ref={inputRef}
							value={value}
							disabled={!editable}
							name={name || ""}
							maxLength={maxLength}
							onChange={onChange}
							onBlur={onBlur}
							onKeyDown={onKeyDown}
							placeholder={placeholder}
							rows={rows}
						/>
					</div>
				</>
			}
		</div>
	)
}

